import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { updateCrop } from "../../redux/cop/artworks";
import { REACT_APP_COP_SERVER } from "../../utils/env";

const ImageCropper = ({ ratio, cropShape = "rect" }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const dispatch = useDispatch();
  const artwork = useSelector((state) => state.artworks.show);

  const onCropChange = useCallback((newCrop) => {
    setCrop(newCrop);
  }, []);

  const onCropComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      if (!croppedArea?.height) return;

      const cropOptions = {
        crop,
        zoom,
        croppedArea,
        croppedAreaPixels,
      };
      dispatch(updateCrop({ crop: cropOptions }));
    },
    [crop, zoom, dispatch]
  );

  const onZoomChange = useCallback((newZoom) => {
    setZoom(newZoom);
  }, []);
  console.log("artwork?.data?.attributes?.preview", artwork?.data?.attributes);

  return (
    <Cropper
      image={`${REACT_APP_COP_SERVER}${artwork?.data?.attributes?.preview}`}
      crop={crop}
      zoom={zoom}
      aspect={ratio}
      cropShape={cropShape}
      onCropChange={onCropChange}
      onCropComplete={onCropComplete}
      onZoomChange={onZoomChange}
    />
  );
};

ImageCropper.propTypes = {
  ratio: PropTypes.number.isRequired,
  cropShape: PropTypes.string,
};

export default ImageCropper;
